import { Component, inject } from '@angular/core';
import { ShellLayoutService } from '_services/shell-layout.service';
import { UnivPrefsService } from '_services/univ-prefs.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-disclaimer-footer',
  templateUrl: './disclaimer-footer.component.html',
  styleUrls: ['./disclaimer-footer.component.css'],
  standalone: true,
})
export class DisclaimerFooterComponent {
  readonly shell = inject(ShellLayoutService);
  readonly ups = inject(UnivPrefsService);
  readonly version = environment.version;
}
